<template>
  <div id="Locker">
    <div class="login-page">
       <transition name="fade">
        <div v-if="!status" class="wallpaper-login"></div>
      </transition>
      <div class="wallpaper-register"></div>

      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-md-6 col-sm-8 mx-auto">
            <div
              id="login-card"
              class="card login"
              v-if="!status"
            >
              <h1>LOCKER</h1>
              <form class="form-group" @submit.prevent="locker">
                <input
                  v-model="std_code"
                  type="text"
                  class="form-control input-style"
                  placeholder="กรุณากรอกรหัสนักศึกษา/รหัสอาจารย์เพื่อรับรหัส locker"
                  required
                />
                <!-- :value="$route.params.id" -->
                <button
                  id="button"
                  type="submit"
                  class="btn btn-success deep-purple btn-block"

                >
                  ยืนยัน
                </button>

                <!-- <p><a href="#">Forgot your password?</a></p> -->
              </form>
            </div>

             <div
              id="locker-card"
              class="card login"
              v-if="status"
            >
              <h3>{{password}}</h3>
                 
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Locker",
  data() {
    return {
      std_code: "",
      namelocker:"",
      token: "dQpojB8WkH7HAZdh223jaqFSB1x5RYoKBjU0BAaVZt8DTVaxO5Sx5DlsErA2Zsu",
      status:false,
      password:""
    };
  },
  mounted() {
  this.namelocker = this.$route.params.id
  },
  methods: {
    // api/booking/get_locker_passcode
    locker() {
    
      let data = {
        token: this.token,
        std_code: this.std_code,
        locker:this.namelocker
      };
      const headers = {
        "content-type": "application/json",
        
      };
       this.$isLoading(true);
      axios.post("https://smartlibrary.ubru.ac.th/api/booking/get_locker_passcode",data,{headers}).then(res =>{
         
          if(res.data.locker_passcode === "" || res.data.locker_passcode ===null){
                 this.password = res.data.msg.message
                 this.status = true
            this.$isLoading(false);
          }else{
            this.password = "รหัส : "+res.data.locker_passcode
            this.status = true
           this.$isLoading(false);
          localStorage.setItem("lockerpass",JSON.stringify(this.password))
          }
        
          
      })
    },
  },
};
</script>

 <style scoped>
#button {
  border-radius: 30px;
}

.input-style {
  border-radius: 30px;
  background-color: #ebf0fc;
  border-color: #ebf0fc;
  color: #9da3b0;
}
#login-card {
  width: 350px;
  border-radius: 25px;
  margin: 150px auto;
}
#locker-card {
  width: 350px;
  border-radius: 25px;
  margin: 150px auto;
}
#regis-card {
  width: 350px;
  border-radius: 25px;
  margin: 150px auto;
}

p {
  line-height: 1rem;
}

.card {
  padding: 20px;
}

.form-group input {
  margin-bottom: 20px;
}
.form-group button {
  margin-bottom: 20px;
}

.login-page {
  align-items: center;
  display: flex;
  height: 100vh;
}
.login-page .wallpaper-login {
  /* background: url(https://www.solidbackgrounds.com/images/2732x2732/2732x2732-dark-pastel-purple-solid-color-background.jpg)
    no-repeat center center; */
  background: -webkit-linear-gradient(-55deg, #754bd4 40%, #2ba3be 100%)
    no-repeat center center;
  background-size: cover;
  height: 100%;
  position: absolute;
  width: 100%;
}

.login-page .fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.wallpaper-register {
  /* background: url(https://www.solidbackgrounds.com/images/2732x2732/2732x2732-dark-pastel-purple-solid-color-background.jpg)
    no-repeat center center; */
  background-size: cover;
  background: -webkit-linear-gradient(-55deg, #2ba3be 40%, #754bd4 100%)
    no-repeat center center;
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: -1;
}

h1 {
  margin-bottom: 1.5rem;
}

.error {
  animation-name: errorShake;
  animation-duration: 0.3s;
}

@keyframes errorShake {
  0% {
    transform: translateX(-25px);
  }
  25% {
    transform: translateX(25px);
  }
  50% {
    transform: translateX(-25px);
  }
  75% {
    transform: translateX(25px);
  }
  100% {
    transform: translateX(0);
  }
}
</style>

